import React, { useEffect } from 'react';

import { Box, Chip, Divider, Link, Stack, Typography, Button } from '@mui/material';
import { useTranslation } from 'react-i18next';

import { ImageAvatar } from 'components/Avatar';
import { PaperCard } from 'components/Card';

import { isoToDateString } from 'utils/dateFormatter';

import { paths } from 'routes';
import { LocalizedLink } from 'website/components/LocalizedLink';
import DelegonSmallLogo from 'assets/Delegon_Small_Logo.png';

const getFirstSentence = (text) => {
  if (!text) return '';
  const firstSentenceMatch = text.match(/[^.!?]+[.!?]/);
  return firstSentenceMatch ? firstSentenceMatch[0].trim() : text.trim();
};

export const LookingForMore = ({
  websiteContext = 'suppliers',
}) => {
  const { t } = useTranslation();
  return (
    <PaperCard
      sx={{
        flex: 1,
        boxShadow: 0,
        borderRadius: 1,
        p: 2,
        display: "flex",
        justifyContent: "center",
        height: 1,
        boxSizing: "border-box"
      }}
    >
      <Stack flexDirection={"column"} gap={2.5} sx={{height:1}}>
        <Stack flexDirection={"row"} gap={{md:2, lg:4}} alignItems={"center"}>
        </Stack>
        <Stack justifyContent="space-between" gap={2} sx={{height:1}}>
          <Stack gap={2} sx={{height:1}}>
            <Typography
              variant="h2"
              sx={{
                fontFeatureSettings: `'liga' off, 'clig' off`,
                fontSize: {xs: "0.875rem", md: "1.125rem"},
                fontWeight: {xs: 500, md: 600},
                lineHeight: {xs: "normal", md: "28px"},
                color: "text.black",
                display: '-webkit-box',
                WebkitBoxOrient: 'vertical',
                WebkitLineClamp: 1,
                overflow: 'hidden',
              }}
            >
              {t('website:homepage.jobAdsSection.lookingForMore.heading')}
            </Typography>
            <Typography
              variant="body2"
              sx={{
                alignContent: "center",  
                fontSize: {xs: "0.75rem", md: "1.125rem"},
                  fontWeight: 400,
                  color: "text.list",
                  display: '-webkit-box',
                  WebkitBoxOrient: 'vertical',
                  WebkitLineClamp: 3,
                  overflow: 'hidden',
                  lineHeight: "175%"
                }}
              >
                {t('website:homepage.jobAdsSection.lookingForMore.description')}
            </Typography>
            <LocalizedLink
              to={paths.website.jobAds}
              state={{websiteContext: websiteContext}}
            >
              <Button
                size="medium"
                variant="contained"
                color="primary"
                sx = {({palette}) =>({
                  width: 1,
                  '&:hover': {
                    backgroundColor: palette.primary.main,
                  },
                })}
              >
                {t('website:homepage.jobAdsSection.lookingForMore.seeMoreButton')}
              </Button>
            </LocalizedLink>
          </Stack>
        </Stack>
      </Stack>
    </PaperCard>
  );
};
